<template>
  <div class="TimeEvent">
    <div class="time">
      <div class="year">{{time.year}}</div>
      <div class="date">
        <p v-for="d in time.date.split(',')">{{d}}</p>
      </div>
    </div>
    <div class="event">
      <div class="main">{{event.main}}</div>
      <div class="sub">{{event.sub}}</div>
    </div>
  </div>
</template>

<script>
 import MyImage from '@/components/Image.vue';
 import Arrow from '@/assets/image/frontpage/arrow-bottom.png';
 export default {
   name: 'TimeEvent',
   props: ['event', 'time', 'color'],
   computed: {
     imgWidth () {
       return this.$store.state.mediaPhone? '2vw': '1.35vw'
     },
     arrow () {
       return Arrow
     },
     inputColor () {
       return {
         'background-color': this.color
       }
     }
   },
   components: {
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .TimeEvent{
   display: flex;
   flex-direction: column;
   align-items: center;
 }
 .time{
   width: 11.76vw;
   height: 6vw;
   border-radius: 0.5vw;
   border: 1px solid #bbb;
   display:flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
 }
 .time .year{
   font-size: 1.2vw;
 }
 .time .date{
   font-size: 0.9vw;
   text-align: center;
 }
.time .date p {
  margin: 3px;
}
 .event{
   width: 12.65vw;
   height: 6vw;
   overflow: visible;
   display: flex;
   flex-direction: column;
   align-items: center;
 }
 .event .arrow{
   margin-top: 1.25vw;
 }
 .event .main{
   margin-top: 0.625vw;
   font-size: 1.04vw;
   white-space: nowrap;
 }
 .event .sub{
   margin-top: 0.4vw;
   font-size: 0.9vw;
   text-align: center;
 }


@media (min-width: 320px) and (max-width: 480px) {
 .time{
   width: 12vw;
   height: 7.73vw;
   border-radius: 0.5vw;
 }
 .time .year{
   font-size: 1.6vw;
 }
 .time .date{
   font-size: 2.1vw;
   text-align: center;
 }
 .event{
   width: 13.38vw;
   height: 9.28vw;
 }
 .event .arrow{
   margin-top: 1.25vw;
 }
 .event .main{
   margin-top: 0.625vw;
   font-size: 2.08vw;
 }
 .event .sub{
   margin-top: 0.4vw;
   font-size: 1.7vw;
 }


 }

</style>
